var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{directives:[{name:"editable",rawName:"v-editable",value:(_vm.blok),expression:"blok"}],staticClass:"code-item-img"},[(_vm.selectedImage)?_c('img',{attrs:{"src":_vm.selectedImage,"alt":"hero Img","loading":"lazy"}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }